const UpDown1 = [
    {id: "0", value: "向上"},    
    {id: "1", value: "向下"}
  ];  
  
  export default UpDown1